import axios from '../../axios.js'
import store from '../../store/store'


axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    store.dispatch('auth/Logout')
  }
  if(error.response.data.error){
    return Promise.reject(error.response.data.error)
  }else{
    return Promise.reject(error.response.data.errors)
  }

})

export default axios
